import { Component } from 'react';
import styles from '../../styles/home/mobile-nav.scss';
import cx from 'classnames';
import { Router } from '../../configs/routes';
import { handleTrack, trackAction } from '../../utils/trackActions';

interface State {
  tab: string;
}

interface NavItem {
  iconUrl: string;
  label: string;
  value: string;
  link?: string;
}

interface Props {
  items: NavItem[];
}

class MobileNav extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { tab: 'best-tax-saving' };
  }

  public highlightTab = () => {
    const { items } = this.props;
    const navItems = items.map(item => item.value);
    const windowScroll =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const offset = 40;
    navItems.filter(Boolean).forEach(item => {
      const el: HTMLElement = document.querySelector(`#${item}`);
      if (el) {
        const topFold = document.getElementById('top-fold-header');
        const appHeader = document.getElementById('app-header');
        const { offsetTop, clientHeight } = el;
        if (
          windowScroll -
            topFold.clientHeight -
            appHeader.clientHeight +
            offset >
            offsetTop - offset &&
          windowScroll -
            topFold.clientHeight -
            appHeader.clientHeight +
            offset <
            offsetTop + clientHeight
        ) {
          if (this.state.tab !== item) {
            this.setState({ tab: item }, () =>
              document
                .querySelector(`div[data-tag="${item}-block"]`)
                .scrollIntoView()
            );
            trackAction('view-section-mobile', 'save', item);
          }
        }
      }
    });
  };

  private handleTagClick = (e: any) => {
    e.preventDefault();
    const selector = e.target.dataset.tag || e.currentTarget.dataset.tag;
    const el = document.querySelector(`.${selector}`);
    const link = e.target.dataset.link || e.currentTarget.dataset.link;
    const key = e.target.key || e.currentTarget.key;
    handleTrack({
      label: `sticky_bottom_navbar_${key}`,
      url: selector || link,
      obj: e.target,
    });
    const appHeader = document.getElementById('app-header');
    if (el) {
      window.scrollTo({
        top:
          window.pageYOffset +
          el.getBoundingClientRect().top -
          appHeader.clientHeight,
        behavior: 'smooth',
      });
    } else if (link) {
      Router.pushRoute(link);
    }
  };

  public componentDidMount() {
    this.highlightTab();
    window.addEventListener('scroll', this.highlightTab);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.highlightTab);
  }

  public render() {
    const { items } = this.props;
    const { tab } = this.state;
    return (
      <div className={cx(styles['nav-container'], 'mobile-only--display')}>
        <ul>
          {items.map(item => {
            const { label, value, iconUrl, link } = item;
            return (
              <li
                className={cx(styles['nav-item'], 'inline-block', 'center', {
                  [styles['nav-item--active']]: value === tab,
                })}
                data-tag={`${value}-block`}
                data-link={link}
                onClick={this.handleTagClick}
                key={label}
              >
                <img src={iconUrl} key={label} />
                <p className="text--sm font--dark-grey font--normal">{label}</p>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default MobileNav;



// WEBPACK FOOTER //
// ./components/home/mobile-nav.tsx